<p class="alert alert-dark mb-5">
  {{ "Please note: editing a setup will not affect images that have already been saved with this setup." | translate }}
</p>

<form [formGroup]="form" novalidate>
  <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
</form>

<div class="form-actions">
  <button [class.loading]="loadingService.loading$ | async" (click)="onSaveClicked()" class="btn btn-primary">
    {{ "Save" | translate }}
  </button>
</div>
